/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Input, { ExInput } from "../extras/Input";
import Button from "../extras/Button";
import { login } from "../../redux/slice/authSlice";
import logo from "../../assets/images/logo.png";
import LoginImg from "../../assets/images/loginImage1.png";
import { projectName } from "../../util/config";
import { IconEye, IconEyeOff } from "@tabler/icons-react";

const Login = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();

  const isAuth = useSelector((state) => state.auth.isAuth);

  useEffect(() => {
    isAuth && navigate("/admin");
  }, [isAuth, navigate]);

  const [email, setEmail] = useState("demo@admin.com");
  const [password, setPassword] = useState("123456");
  const [error, setError] = useState({
    email: "",
    password: "",
  });

  const submit = async () => {
    if (!email || !password) {
      let error = {};
      if (!email) error.email = "Email is required";
      if (!password) error.password = "Password is required";
    } else {
      const loginData = {
        email,
        password,
      };

      let response = await dispatch(login(loginData)).unwrap();
      console.log("response", response);
      response?.status && navigate("/admin");
    }
  };

  const demoSubmit = (e) => {
    e.preventDefault();
    setEmail("demo@admin.com");
    setPassword("123456");

    const loginData = {
      email: "demo@admin.com",
      password: "123456",
    };
    dispatch(login(loginData)).unwrap();
  };

  const [type, setType] = useState("password")  
  const hideShow = () => {
    type === "password" ? setType("text") : setType("password");
  };

   const handleKeyPress = (event) => {
    if (email == "demo@admin.com" || password == "123456") {
      if (event.key === "Enter") {
        event.preventDefault();
        demoSubmit();
      }
    } else {
      if (event.key === "Enter") {
        event.preventDefault();
        submit();
      }
    }
  };

  return (
    <>
      {/* <div className="mainLoginPage">
        <div className="loginDiv" style={{ width: "100%" }}>
          <div className="loginPage m-auto">
            <div className="loginTitle mb-3  d-flex ">
              <img src={logo} style={{ width: "50px" }} alt="logo" />
            </div>
            <div className="fw-bold text-theme  me-auto my-auto welComeTitle">
              Welcome Back
            </div>
            <h1>Log In !</h1>
            <h6 className="fw-bold text-theme  me-auto my-auto fs-15 py-2 title">
              Please,Enter Your Email id and Password
            </h6>
            <div>
              <div className="col-12 ">
                <ExInput
                  type={`text`}
                  id={`email`}
                  name={`email`}
                  label={`Email`}
                  value={email}
                  placeholder={`Email`}
                  errorMessage={error.email && error.email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        email: `email Id is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        email: "",
                      });
                    }
                  }}
                />
              </div>
              <div className="col-12 ">
                <ExInput
                  type={`password`}
                  id={`password`}
                  name={`password`}
                  value={password}
                  label={`Password`}
                  placeholder={`Password`}
                  errorMessage={error.password && error.password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    if (!e.target.value) {
                      return setError({
                        ...error,
                        password: `password is Required`,
                      });
                    } else {
                      return setError({
                        ...error,
                        password: "",
                      });
                    }
                  }}
                />
              </div>
              <div className="loginButton d-flex gx-2 justify-content-center">
                <Button
                  type={`submit`}
                  className={`bg-theme text-nowrap text-light cursor m10-top col-6 mx-2 `}
                  text={`Demo login`}
                  onClick={demoSubmit}
                  style={{ borderRadius: "30px" }}
                />
                <Button
                  type={`submit`}
                  className={`bg-theme text-light cursor m10-top col-6 mx-2`}
                  text={`Log In`}
                  onClick={submit}
                  style={{ borderRadius: "30px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div> */}

       <div className=" d-flex " style={{ height: "100vh" }}>
        <div className=" d-md-block d-none  w-100">
          <img src={LoginImg} alt="Login" className=" w-100 h-100" />
        </div>
        <div className=" w-100">
          <div className="align-items-center d-flex h-100 justify-content-center w-100">
            <div className="w-50 w-md-100">
              <div>
                <img
                  src={logo}
                  alt="Logo"
                  className="mb-2"
                  height={75}
                  width={75}
                />
              </div>
              <h2 className="fw-semibold">Login to your account</h2>
              <p className="text-secondary">
                Let's connect, chat, and spark real connections. Enter your
                credentials to continue your journey on {projectName}.
              </p>
              <div className="custom-input">
              <label >Email</label>
              <input
                className="form-control border"
                name={"email"}
                id={`loginEmail`}
                placeholder={"Enter Email"}
                type={`email`}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...error,
                      email: `Email Is Required`,
                    });
                  } else {
                    return setError({
                      ...error,
                      email: "",
                    });
                  }
                }}
                autoComplete="username"
                onKeyPress={handleKeyPress}
              />
              </div>
              <div className="custom-input">
                <label >Password</label>
                <div className="input-group">
                  <input
                    type={type}
                    value={password}
                    name="password"
                    className="form-control border border-end-0 password-input"
                    placeholder="Enter Password"
                    onChange={(e) => {
                      setPassword(e.target.value);
                      if (!e.target.value) {
                        return setError({
                          ...error,
                          password: `Password Is Required`,
                        });
                      } else {
                        return setError({
                          ...error,
                          password: "",
                        });
                      }
                    }}
                    autoComplete="current-password"
                    onKeyPress={handleKeyPress}
                  />
                  <span
                    className="input-group-text border border-start-0 bg-white"
                    id="basic-addon2"
                  >
                    {
                      type === "password" ? (
                        <IconEyeOff onClick={hideShow} className="text-secondary cursor-pointer"/>
                      ) : (
                        <IconEye onClick={hideShow} className="text-secondary cursor-pointer" />
                      )
                    }
                  </span>
                </div>
                <p className="errorMessage">
                  {error.password && error.password}
                </p>
              </div>

              {/* <div className="w-100" >
                <h4
                  className="cursor-pointer fs-6 text-end text-secondary"
                  style={{ fontWeight: 500, fontSize: "small" }}
                  onClick={() => navigate("/forgotPassword")}
                >
                  Forgot Password ?
                </h4>
              </div> */}
              <div className="d-flex flex-column justify-content-center w-100 gap-3 mt-4">
                <Button
                  text={"Login"}
                  className={"login-btn  w-100 py-2 fw-medium"}
                  onClick={submit}
                />
                <Button
                  text={"Demo Login"}
                  className={"login-btn demologin w-100 py-2 fs-6 fw-medium"}
                  onClick={demoSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
